var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommentOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.292 4A2.708 2.708 0 0 1 21 6.708v8.987a2.708 2.708 0 0 1-2.708 2.708H7.882l-3.328 3.329C3.98 22.305 3 21.899 3 21.088V6.708A2.708 2.708 0 0 1 5.708 4h12.584zm.377 1.365H5.296a.888.888 0 0 0-.888.887l-.017 13.636 2.042-2.041c.17-.17.777-.738 1.018-.738h11.2c.491 0 .888-.397.888-.887l.018-9.97a.888.888 0 0 0-.888-.887zm-3.917 2.883c.308.307.332.781.055 1.058L13.113 11l1.694 1.694c.277.277.253.751-.055 1.058-.307.308-.781.332-1.058.055L12 12.113l-1.694 1.694c-.277.277-.751.253-1.058-.055-.308-.307-.332-.781-.055-1.058L10.887 11 9.193 9.306c-.277-.277-.253-.751.055-1.058.307-.308.781-.332 1.058-.055L12 9.887l1.694-1.694c.277-.277.751-.253 1.058.055z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentOff);
export default __webpack_public_path__ + "static/media/comment-off.0bc2dcf5.svg";
export { ForwardRef as ReactComponent };